import { Grid } from "@mui/material";
import { FieldState } from "final-form";
import { Field } from "react-final-form";
import FormContainer from "../../../components/FormContainer";
import Select from "../../../components/select/Select";
import TransferList from "../../../components/TransferList";
import {
  AdministrateurBienDetail,
  UtilisateurDetailAdbProfilSites,
} from "../../../services/Api/swagger/api.js";
import { construireListAdbDetail, construireListProfils } from "../helpers";
import { useEffect, useState } from "react";
import { useGetAdbDetailForUserForm } from "../../../hooks/AdministrateurDeBien";
import LoadingBoundary from "../../../components/LoadingBoundary";

interface Props {
  selectedAdb?: AdministrateurBienDetail;
  valueAdb?: UtilisateurDetailAdbProfilSites;
  fields: FieldState<any[]>;
  utilisateurConnecteAdb?: UtilisateurDetailAdbProfilSites[];
  index: number;
  adb: any;
  disabled?: boolean;
}

function AjouterSitesAdb({
  valueAdb,
  index,
  adb,
  disabled,
  utilisateurConnecteAdb,
  selectedAdb,
}: Props) {
  const [adbsDetail, setAdbsDetail] = useState<
    AdministrateurBienDetail[] | undefined
  >(selectedAdb ? [selectedAdb] : undefined);

  const {
    mutate: mutateAdbDetail,
    isLoading: adbFetching,
    error: adbError,
    data: adbDetailData,
  } = useGetAdbDetailForUserForm();
  const getAdbDetail = (param: number) => {
    mutateAdbDetail(param);
  };

  useEffect(() => {
    if (adbDetailData) {
      let newAdbDetail = adbsDetail;
      const idExistant = adbsDetail?.findIndex(
        (detail) => detail.identifiant === adbDetailData?.identifiant,
      );
      if (idExistant === -1) {
        newAdbDetail = adbsDetail?.concat([adbDetailData]);
      }
      setAdbsDetail(newAdbDetail);
    }
  }, [adbDetailData]);

  useEffect(() => {
    if (valueAdb?.refAdb) {
      getAdbDetail(valueAdb.refAdb);
    }
  }, [valueAdb?.refAdb]);

  const filtrerAdbDetail =
    adbsDetail &&
    valueAdb &&
    adbsDetail.find((adb2) => adb2.identifiant === Number(valueAdb.refAdb));

  // Si utilisateur connecté a un role ADB :
  //  On récupère les infos de l'ADB sélectionné pour avoir les sites autorisés par cet utilisateur

  const filtrerAdb =
    filtrerAdbDetail &&
    utilisateurConnecteAdb &&
    utilisateurConnecteAdb.find(
      (detail) => detail.refAdb === filtrerAdbDetail.identifiant,
    );

  // La liste des sites accessibles à l'utilisateur connecté SI utilisateur ADB
  const sites = filtrerAdb && filtrerAdb.sites;
  const filtrerSites =
    sites && filtrerAdbDetail && filtrerAdbDetail.sites
      ? filtrerAdbDetail.sites.filter(
          (site) => site.numero && sites.includes(site.numero),
        )
      : filtrerAdbDetail && filtrerAdbDetail.sites;

  const optionsAdbDetail =
    (filtrerAdbDetail &&
      filtrerAdbDetail.identifiant &&
      construireListAdbDetail(filtrerSites, filtrerAdbDetail.identifiant)) ||
    [];
  // on construit la liste des profils (ils sont tous autorisés par défaut pour utilisateur BESSE OU ADB)
  const optionsProfils =
    (filtrerAdbDetail &&
      filtrerAdbDetail.applications &&
      filtrerAdbDetail.applications[0] &&
      filtrerAdbDetail.applications[0].profils &&
      construireListProfils(filtrerAdbDetail.applications[0].profils)) ||
    [];
  return (
    <>
      <h3>
        {filtrerAdbDetail &&
          filtrerAdbDetail.nom + " - " + filtrerAdbDetail.ville}
      </h3>
      <FormContainer key={index}>
        <LoadingBoundary loading={adbFetching} error={adbError}>
          <>
            <Grid container spacing={1}>
              <Grid item>
                <Field
                  name={`${adb}.profil`}
                  component={Select}
                  label="Profil"
                  options={optionsProfils}
                  required
                  disabled={disabled}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              {optionsAdbDetail && optionsAdbDetail.length > 0 && (
                <Grid item>
                  <Field
                    name={`${adb}.sites`}
                    component={TransferList}
                    label="Sites"
                    required
                    options={optionsAdbDetail}
                    disabled={disabled}
                  />
                </Grid>
              )}
            </Grid>
          </>
        </LoadingBoundary>
      </FormContainer>
    </>
  );
}

export default AjouterSitesAdb;
